import React, { useEffect, useState } from "react";
import ModalComponent from "../../../components/modals/ModalComponent";
import SkeletonTable from "../../../components/table/SkeletonTable";
import View from "../../../assets/View";
import { ReactComponent as Download } from "../../../assets/download.svg";
import { DownloadFileFolderApi } from "../../../api/request/clients/clients";
import Spinner from "../../../components/loader/Spinner";
import { saveAs } from "file-saver";
import toast from "react-hot-toast";

const ViewAllDoc = ({ data, isLoading, isOpen, setIsOpen }) => {

  const [tableData, setTableData] = useState([]);
  const [downloadingDocId, setDownloadingDocId] = useState(null);

  const columns = [
    {
      title: "Section Name",
      dataIndex: "section_name",
      render: (value) => (value ? value : "--"),
    },
    {
      title: "Question",
      dataIndex: "field_label",
      render: (value) => <p className="truncate w-[200px]" title={value}>{value}</p>
    },
    {
      title: "Document Name",
      dataIndex: "original_name",
      render: (value) => <p className="truncate w-[200px]" title={value}>{value || "--"}</p>,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (value) => value,
    },
  ];

  const downloadFileFolderManager = async (item) => {
    try {
      setDownloadingDocId(item.document_id);
      let params = { doc_id: item?.document_id, user_id: data?.user_id };
      const headers = { responseType: "arraybuffer" };
      const res = await DownloadFileFolderApi(params, headers);
      const blob = new Blob([res?.data]);
      const fileName = item?.original_name;
      saveAs(blob, fileName);
    } catch (error) {
      if (error?.response?.data?.error)
        toast.error(error?.response?.data?.error);
    } finally {
      setDownloadingDocId(null);
    }
  };

  useEffect(() => {
    if (Array.isArray(data?.uploaded_document_list)) {
      const transformed = data.uploaded_document_list.map((item) => ({
        ...item,
        action: (
          <div className="flex items-center cursor-pointer gap-3">
            <button onClick={() => window.open(item?.path, "_blank")}>
              <View />
            </button>
            {downloadingDocId === item.document_id ? (
              <Spinner />
            ) : (
              <button onClick={() => downloadFileFolderManager(item)}>
                <Download className="size-5" />
              </button>
            )}
          </div>
        ),
      }));
      setTableData(transformed);
    }
  }, [data]);

  return (
    <div>
      <ModalComponent
        setIsOpen={setIsOpen}
        isOpen={isOpen}
        width={1000}
      >
        <div className="mb-5 text-center font-semibold text-xl">
          <p>View All Documents</p>
          <p className="capitalize">{`${data?.service_name_slug} (#${data?.file_number})`}</p>
        </div>
        <SkeletonTable
          columns={columns}
          data={tableData}
          isLoading={isLoading}
        />
      </ModalComponent>
    </div>
  );
};

export default ViewAllDoc;
